import {XHRBackend, Http, RequestOptions} from "@angular/http";
import {InterceptedHttp} from "./intercepted-http";
import { AdalService } from "./services/adal.service";

export function httpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions, adalService : AdalService): Http {
    return new InterceptedHttp(xhrBackend, requestOptions, adalService);
}


// WEBPACK FOOTER //
// ./src/app/http-factory.ts